import React, { useMemo } from 'react';

import { useProjectIssueTypes } from 'src/services/pagerduty/projectIssueTypes';

import Field from 'src/views/components/Form/Field';

import IssueTypeSelect from './components/IssueTypeSelect';
import ProjectSelect from './components/ProjectSelect';

const ProjectIssueType = ({
  values: { projectIssueType: values = {} },
  touched: { projectIssueType: touched = {} },
  errors: { projectIssueType: errors = {} },
  onChange: onChangeProp,
  onBlur: onBlurProp
}) => {
  const { projectIssueTypes = [] } = useProjectIssueTypes();

  const unique = (value, index, self) => self.map(i => i.id).indexOf(value.id) === index;
  const projects = useMemo(
    () => projectIssueTypes.map(p => p.project).filter(unique),
    [projectIssueTypes]
  );
  const issueTypes = useMemo(
    () => (
      projectIssueTypes
        .filter(p => p.project.key === values.project)
        .flatMap(i => i.issue_types)
        .filter(unique)
    ),
    [projectIssueTypes, values.project],
  );

  const onChange = ({ target: { name, value } }) => {
    const changes = {
      ...values,
      [name]: value,
    };
    if (name === 'project') changes.issueType = '';

    onChangeProp({
      target: {
        name: 'projectIssueType',
        value: { ...changes },
      }
    });
  };

  const onBlur = ({ target: { name } }) => {
    const changes = {
      ...touched,
      [name]: true,
    };
    if (name === 'project') delete changes.issueType;

    onBlurProp({
      target: {
        name: 'projectIssueType',
        value: { ...changes },
      }
    });
  };

  return (
    <>
      <div style={{ maxWidth: 250 }}>
        <Field label="Project" isRequired errorMessage={touched.project && errors.project}>
          <ProjectSelect
            name="project"
            value={values.project}
            projects={projects}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Field>
      </div>

      <div style={{ maxWidth: 250 }}>
        <Field label="Issue Type" isRequired errorMessage={touched.issueType && errors.issueType}>
          <IssueTypeSelect
            name="issueType"
            value={values.issueType}
            issueTypes={issueTypes}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Field>
      </div>
    </>
  );
};

export default ProjectIssueType;
